enum TaxIdType {
  SSN = 1,
  EIN = 2,
}

export default TaxIdType;
